const cLogdDefaultStyle = 'background: #F68B58; color: #fff; border-radius: 10px;';
const cLogSuccessStyle = 'background: #28a745; color: #fff; border-radius: 10px;';
const cLogErrorStyle = 'background: #DC3545; color: #fff; border-radius: 10px;';
const cLogtmp = 'background: #2C5DAB; color: #fff; border-radius: 10px;';

export default class CMSCustomComponentHelper {
  constructor(details) {
    let { 
      name = 'CMSCustomComponent', 
      id = 'elementId',
      props = {}, 
      template = '',
      debugMode = false,
      templateMode = false,
      lang = 'en_US',
      initFrom = 'cms',
      data = {},
      style = '',
      version = 'v0'
    } = details
    this.name = name
    this.id = props['data']['config']['id'] ?? id
    this.props = props ?? {}
    this.template = this.parseComponentProps(template) ?? ''
    this.debugMode = this.parseComponentProps(props['debugMode'], 'json') ?? debugMode
    
    this.lang = window.Server.lang ?? lang 
    this.initFrom = props['initFrom'] ?? initFrom
    this.version = this.parseComponentProps(props['version']) ?? version
    this.data = props['data'] ?? data
    this.style = props['style'] ?? style

    this.templateMode = this.parseComponentProps(props['data']['config']['templateMode'], 'json') ?? templateMode
    this.config = props['data']['config']
    this.viewport = (window.innerWidth < 769) ? 'mobile' : 'desktop'
    this.mode = ''
  }

  parseComponentProps(target, targetType = 'string') {
    if ( /^\s*$/.test(target) || target == "null" || target == undefined) {
      return null
    } else {
      switch(targetType) {
        case 'json':
          return JSON.parse(target)
        case 'string':
          return target
        case 'number':
          return Number(target)
      }
    }
  }

  parseDisplayText(target) {
    console.log(this.name + 'parseDisplayText: ', target.includes('#double-quote#'))
    if (target.includes('#double-quote#')) {
        return target.replaceAll('#double-quote#', '"')
    } else {
        return target
    }
  }

  parseStyle() {
    let css = {}
    Object.keys(this.style['desktop']).forEach((i)=>{
      Object.keys(this.style['desktop'][i]).forEach((j)=>{
        css[`--${this.name}-${i}-${j}-desktop`] = `${this.style['desktop'][i][j]}`
      })
    })
    Object.keys(this.style['mobile']).forEach((i)=>{
      Object.keys(this.style['mobile'][i]).forEach((j)=>{
        css[`--${this.name}-${i}-${j}-mobile`] = `${this.style['mobile'][i][j]}`
      })
    })
    return css
  }

  parseTemplateHTML() {
    if (this.templateMode) {
      let html = this.template
      let result = []
      let templateKey = []
      if (Array.isArray(this.data.template)) {
        templateKey = Object.keys(this.data.template[0])
        this.data.template.forEach((item) => {
          templateKey.forEach((key, index) => {
            let displayText = this.parseDisplayText(item[key])
            html = html.replaceAll('{{ ' + key + ' }}', displayText)
          })
          result.push(html)
          html = this.template
        })
        return result
      } else {
        templateKey = Object.keys(this.data.template)
        templateKey.forEach((key, index) => {
          let displayText = this.parseDisplayText(this.data.template[key])
          html = html.replaceAll('{{ ' + key + ' }}', displayText)
        })
        result.push(html)
        return result[0]
      }
    } 
  }

  setComponent(target) {
    target.setAttribute('id', this.id)
    target.dataset.lang = this.lang
    target.dataset.componentVersion = this.version
    this.setMode(target)
    window.addEventListener('resize', ()=>{
      this.setMode(target)
    })
    this.cLog('constructor', this,cLogSuccessStyle)
  }

  setMode(target) {
    if (window.innerWidth < 769) {
      this.viewport = 'mobile'
    } else {
      this.viewport = 'desktop'
    }
    target.dataset.viewport = this.viewport

    if (this.parseComponentProps(this.config['mode']) == null) return

    if (window.innerWidth < 769) {
      this.mode =  ( this.parseComponentProps(this.config['mode']['mobile']) ?? this.config['mode'] )
    } else {
      this.mode =  ( this.parseComponentProps(this.config['mode']['desktop']) ?? this.config['mode'] )
    }
    target.dataset.mode = this.mode
  }

  getMode() {
    return this.mode
  }
  
  addClassToTarget(target, targetClassName) {
    if (target.classList.contains(targetClassName)) return 
    target.classList.add(targetClassName)
  }

  removeClassFromTarget(target, targetClassName) {
    if (!target.classList.contains(targetClassName)) return 
    target.classList.remove(targetClassName)
  }

  toggleClassFromTarget(target, targetClassName) {
    target.classList.toggle(targetClassName)
  }

  dispatchCustomEvent(target) {
    if (target) {
      document.dispatchEvent(new CustomEvent(target));
    } else {
      this.cLog('dispatchCustomEvent', 'no event name', cLogErrorStyle)
    }
    
  }
  
  cLog(targetLabel, targetData, targetStyle = 'background: #F68B58; color: #fff; border-radius: 10px;') {
    if (this.debugMode) {
        console.log('%c ' + this.name + ' - ' + targetLabel + ': ', targetStyle, targetData);
    }
  }

  pause(ms = 1000) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  
}

window.CMSCustomComponentHelper = CMSCustomComponentHelper;


// WEBPACK FOOTER //
// ./src/cms-custom-components.js